class PDPPromoMessage extends HTMLElement {
  constructor() {
    super()
    this.promoMessageContainer = null
    this.variantsPromoMessages =
      window.__THEME_GLOBALS__?.variants_promo_message || []
  }

  connectedCallback() {
    this.promoMessageContainer = this.querySelector('.pdp-promo-message')

    if (this.promoMessageContainer) {
      window.addEventListener(
        'variant-change',
        this.handleVariantChange.bind(this)
      )
    } else {
      console.warn('PDPPromoMessage: Could not find promo message container')
    }
  }

  disconnectedCallback() {
    window.removeEventListener(
      'variant-change',
      this.handleVariantChange.bind(this)
    )
  }

  handleVariantChange(event) {
    const { variant } = event.detail

    if (variant && variant.id) {
      this.updatePromoMessage(variant.id)
    }
  }

  updatePromoMessage(variantId) {
    if (!this.promoMessageContainer || !variantId) return

    let promoData = this.variantsPromoMessages.find(
      (variant) => variant.id === variantId
    )

    if (promoData.promo_message === '') {
      promoData = {
        promo_message: window.__THEME_GLOBALS__?.product_promo_message || null,
        end_date: window.__THEME_GLOBALS__?.product_promo_end_date || null,
        product_promo_text_color:
          window.__THEME_GLOBALS__?.product_promo_text_color || null,
      }
    }

    if (
      promoData &&
      promoData.promo_message &&
      promoData.promo_message !== ''
    ) {
      const now = new Date()
      const endDate = new Date(promoData.end_date)
      if (now < endDate || promoData.end_date === null) {
        this.promoMessageContainer.innerHTML = promoData.promo_message
        this.promoMessageContainer.style.display = 'block'
      } else {
        this.promoMessageContainer.style.display = 'none'
      }
      if (promoData.product_promo_text_color) {
        this.promoMessageContainer.style.color =
          promoData.product_promo_text_color
        this.promoMessageContainer.style.borderColor =
          promoData.product_promo_text_color
      }
    } else {
      this.promoMessageContainer.style.display = 'none'
    }
  }
}

customElements.define('pdp-promo-message', PDPPromoMessage)
